<template>
  <div>
    <Box theme="box-primary" :title="'PHÍ CUỘC GỌI HÀNG THÁNG'">
      <div slot="content">
        <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>

          <template #empty="scope">
            <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
          </template>

          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template v-slot:cell(payment_date)="data">
            <span v-if="!(data.item.editMode || data.item.addMode)">{{data.item.payment_date | format_date}}</span>
            <date-picker v-else v-model="data.item.payment_date" valueType="format" :class="payment_date_valid ? '' : 'date-picker-error' "></date-picker>
          </template>
          <template v-slot:cell(on_net_fee)="data">
            <span v-if="!(data.item.editMode || data.item.addMode)">{{data.item.on_net_fee | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.on_net_fee"/>
          </template>
          <template v-slot:cell(off_net_fee)="data">
            <span v-if="!(data.item.editMode || data.item.addMode)">{{data.item.off_net_fee | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.off_net_fee"/>
          </template>
          <template v-slot:cell(billing_month)="data">
            <span v-if="!(data.item.editMode || data.item.addMode)">{{data.item.billing_month | format_month}}</span>
            <date-picker v-else v-model="data.item.billing_month" valueType="format" :class="billing_month_valid ? '' : 'date-picker-error' " format="YYYY-MM" type="month"></date-picker>
          </template>

          <template #head(actions)="data">
            <b-button variant="success" @click="addItemToTable" class="mr-2" :disabled="id === null || id === undefined || !isEditable"><span class="glyphicon glyphicon-plus" aria-hidden="true" ></span>
            </b-button>
          </template>

          <template v-slot:cell(actions)="data">
            <b-button v-if="!data.item.editMode && data.item.addMode" variant="warning" v-b-tooltip.hover title="Lưu" @click="save(data.item)" :disabled="!isEditable || saving"><i class="fa fa-floppy-o"/></b-button>
            <b-button v-if="data.item.editMode && !data.item.addMode" variant="warning" v-b-tooltip.hover title="Lưu" @click="update(data.item)" :disabled="!isEditable || saving"><i class="fa fa-floppy-o"/></b-button>
            <b-button v-if="!data.item.editMode && !data.item.addMode" variant="warning" v-b-tooltip.hover title="Sửa" @click="edit(data.item)" :disabled="!isEditable || saving"><i class="fa fa-edit"/></b-button>
            <b-button v-if="data.item.editMode || data.item.addMode" variant="danger" v-b-tooltip.hover title="Huỷ" @click="discard(data.item)" :disabled="!isEditable || saving"><i class="fa fa-times"/></b-button>
            <b-button v-if="!data.item.editMode && !data.item.addMode" variant="danger" v-b-tooltip.hover title="Xoá" @click="remove(data.item)" :disabled="!isEditable || saving"><i class="fa fa-trash"/></b-button>
          </template>
        </b-table>
      </div>

      <div slot="footer" class="d-flex align-items-center justify-content-between">
        <div class="page-size-container">
          <span>Hiển thị</span>
          <b-form-select
            id="pageSize"
            v-model="pageSize"
            :options="pageSizes"
            required
          ></b-form-select>
          <span>  dòng</span>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="pageSize"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </Box>
  </div>
</template>

<script>
import Box from '../../components/Box.vue'
import Utils from '../../common/utils'
import DatePicker from 'vue2-datepicker'
import {mapActions, mapGetters} from 'vuex'
import {PERMISSION_KEY} from '../../common/constant'
import {isNumber} from 'lodash'
import {eventBus} from '../../main'
import moment from 'moment/moment'
import PhoneNumberMonthlyFeeApi from '../../api/phoneNumberMonthlyFeeApi'

export default {
  name: 'PhoneNumberMonthlyFee',
  components: {
    Box,
    DatePicker,
  },
  props: {
    id: {
      type: Number,
      required: false,
    }
  },
  data () {
    return {
      company: null,
      fields: [
        {
          key: 'payment_date',
          label: 'Ngày nhập phí',
          show: true
        },
        {
          key: 'on_net_fee',
          label: 'Phí nội mạng',
          show: true
        }, {
          key: 'off_net_fee',
          label: 'Phí ngoại mạng',
          show: true
        }, {
          key: 'billing_month',
          label: 'Tháng tính phí',
          show: true
        }, {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 130px',
          class: 'actions-cell',
          show: true
        }
      ],
      saving: false,
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      orderDetail: {
        order_id: this.orderId,
        type: this.type,
        company_id: null,
        product_id: null,
        product_name: null,
        quantity: 0,
        price: 0,
        discount_value: 0,
        remaining_payment_amount: 0,
        annual_paid_payment_amount: 0,
        total_payment_amount: 0,
        paid_payment_amount: 0,
        annual_remaining_payment_amount: 0,
        annual_payment_amount: 0,
        debt: 0,
        due_date: null,
        invoice: null,
        renew_date: null,
        payment_date: null,
        addition_fee: 0,
        charge_from_date: null,
        charge_to_date: null
      },
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      items: [
      ],
      modalTitle: 'Thêm mới',
      isEditable: true,
      payment_date_valid: true,
      billing_month_valid: true,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorQuantity: function () {
      return !isNumber(this.orderDetail.quantity)
    },
    errorPrice: function () {
      return !isNumber(this.orderDetail.price)
    }
  },
  mounted () {
    this.isEditable = this.hasEditPermission()
    if (this.id) {
      this.reloadMonthlyFees()
    }
  },
  created () {
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  },
  methods: {
    ...mapActions([
      'updateInitOrderDetailId'
    ]),
    reloadMonthlyFees () {
      this.company = Utils.getCompanyByUserInfo(this.userInfo)
      this.filter()
    },
    validate () {
      return true
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_MANAGER) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_TECHNICAL) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_ADMIN)
    },
    buildFilterData () {
      return {phone_number_id: this.id}
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      PhoneNumberMonthlyFeeApi.filter(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    edit (selectedRow) {
      this.items = this.items.map(item => {
        if (item.id === selectedRow.id) {
          item.editMode = true
          item.addMode = false
        }
        return item
      })
    },
    notifyChangeOrderDetail () {
      eventBus.$emit('orderDetailChanged')
    },
    save (selectedRow) {
      if (selectedRow.payment_date === '' || selectedRow.payment_date === null) {
        this.payment_date_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Ngày nhập phí không được bỏ tống')
        return
      }
      if (selectedRow.billing_month === '' || selectedRow.billing_month === null) {
        this.billing_month_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Tháng tính phí không được bỏ trống')
        return
      }
      this.loading = true
      this.saving = true
      const dto = {
        ...selectedRow,
        company_id: this.company.id,
        phone_number_id: this.id,
        billing_month: selectedRow.billing_month + '-01'
      }
      PhoneNumberMonthlyFeeApi.create(dto).then(res => {
        Utils.successToast(this.$bvToast)
        selectedRow.editMode = false
        selectedRow.addMode = false
        this.loading = false
        this.saving = false
        selectedRow.id = res.data.data.id
      }).catch(() => {
        Utils.failedToast(this.$bvToast)
      })
    },
    update (selectedRow) {
      if (selectedRow.payment_date === '' || selectedRow.payment_date === null) {
        this.payment_date_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Ngày nhập phí không được bỏ tống')
        return
      }
      if (selectedRow.billing_month === '' || selectedRow.billing_month === null) {
        this.billing_month_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Tháng tính phí không được bỏ trống')
        return
      }
      this.loading = true
      this.saving = true
      const dto = {
        ...selectedRow,
        billing_month: selectedRow.billing_month.length > 7 ? selectedRow.billing_month : selectedRow.billing_month + '-01'
      }
      PhoneNumberMonthlyFeeApi.update(dto).then(res => {
        Utils.successToast(this.$bvToast)
        selectedRow.editMode = false
        selectedRow.addMode = false
        this.loading = false
        this.saving = false
      }).catch(() => {
        Utils.failedToast(this.$bvToast)
      })
    },
    discard (selectedRow) {
      if (selectedRow.addMode) {
        this.items = this.items.filter(item => item.id !== selectedRow.id)
      } else {
        this.items = this.items.map(item => {
          item.editMode = false
          return item
        })
      }
    },
    remove (item) {
      if (item.id) {
        this.$bvModal.msgBoxConfirm('Xoá không thể khôi phục, bạn có chắc chắn xoá?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            PhoneNumberMonthlyFeeApi.remove(item.id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
            }).catch(() => {
              Utils.failedToast(this.$bvToast)
            })
          }
        })
      }
    },
    addItemToTable () {
      const item = {
        id: this.$uuid.v1(),
        payment_date: moment().format('yyyy-MM-DD'),
        off_net_fee: 0,
        on_net_fee: 0,
        billing_month: moment().format('yyyy-MM'),
        addMode: true,
        editMode: false,
      }
      this.items.push(item)
    }
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/PhoneNumberMonthlyFee.vue